window.unsavedChanges = false;

function liveScoringDraftKey(teamId, playerId, holeId) {
  return teamId + '_' + playerId + '_' + holeId;
}

function liveScoringHiddenInputSelector(teamId, playerId, holeId) {
  return '#live-scoring-input-' + teamId + '-' + playerId + '-' + holeId;
}

function liveScoringParseEntries($page) {
  try {
    return JSON.parse($page.attr('data-entries') || '{}');
  } catch (e) {
    return { teams: [] };
  }
}

function liveScoringIsMobileLayout() {
  return window.matchMedia('(max-width: 767.98px)').matches;
}

function liveScoringClampParDiff(parDiff) {
  if (parDiff > 2) return 2;
  if (parDiff < -2) return -2;
  return parDiff;
}

function liveScoringAllowX() {
  return !!gon.allow_x;
}

function liveScoringDisplayForValue(value, hole, entry) {
  if (entry && !entry.editable && entry.displayValue !== undefined && entry.displayValue !== null) {
    return entry.displayValue;
  }
  if (value === 'X' && hole && gon['par_' + hole.par]) {
    return gon['par_' + hole.par] + 'X';
  }
  if (value === '' || value === null || value === undefined) return '';
  return value;
}

function liveScoringParDiffForValue(value, par) {
  if (value === '' || value === 'X' || value === null || value === undefined) return 0;
  var score = parseInt(value, 10);
  if (isNaN(score)) return 0;
  return liveScoringClampParDiff(score - par);
}

function liveScoringScoreValueForTotal(value, par) {
  if (value === '' || value === null || value === undefined) return 0;
  if (value === 'X') {
    var missing = gon['par_' + par];
    return missing ? parseInt(missing, 10) : 0;
  }
  var numeric = parseInt(value, 10);
  return isNaN(numeric) ? 0 : numeric;
}

function liveScoringIsEmptyScoreValue(value) {
  return value === '' || value === null || value === undefined;
}

function liveScoringNumericScoreValue(value) {
  if (liveScoringIsEmptyScoreValue(value) || value === 'X') return null;

  var numeric = parseInt(value, 10);
  return isNaN(numeric) ? null : numeric;
}

function liveScoringNormalizeInputValue($input) {
  var value = $input.val();
  if (value === 'x') value = 'X';
  if (['X', 'x'].indexOf(value) !== -1 && !liveScoringAllowX()) value = '';
  if ((value !== 'X' && !parseInt(value, 10)) || parseInt(value, 10) === 0) value = '';
  if (parseInt(value, 10) >= 20) value = value.charAt(1);
  $input.val(value);
  return value;
}

function liveScoringShouldAdvanceToNextInput(value) {
  if (value === 'x') value = 'X';
  return parseInt(value, 10) > 1 || value === 'X';
}

function liveScoringApplyScoreInputMask($inputs) {
  if (typeof $.fn.mask !== 'function' || $inputs.length === 0) return;

  $inputs.mask('Z9', {
    translation: {
      Z: {
        pattern: /[X|x|0-9]/,
        optional: true,
      },
    },
  });
}

function liveScoringParDiffDisplayHtml(display, parDiff) {
  return (
    '<div class="mobile-app-score d-flex align-items-center justify-content-center w-100 h-100">' +
    '<div data-par-diff="' +
    parDiff +
    '"><span class="font-weight-bold">' +
    display +
    '</span></div></div>'
  );
}

function liveScoringFocusNextScoreInput($input) {
  var value = $input.val();
  if (!liveScoringShouldAdvanceToNextInput(value)) return;

  var $td = $input.closest('td');
  var $row = $input.closest('tr');
  var $tableWrap = $input.closest('.table-responsive');
  var $nextTd = $td.next();

  if ($nextTd.hasClass('live-scoring-desktop-total')) {
    $nextTd = $nextTd.next();
  }

  var $nextInput = $nextTd.find('.live-scoring-desktop-score-input');

  if (!$nextInput.length) {
    $nextInput = $td.nextAll('td').find('.live-scoring-desktop-score-input').first();
  }

  if ($nextInput.length) {
    if ($tableWrap.length) $tableWrap[0].scrollLeft += 80;
    $nextInput.trigger('focus');
    return;
  }

  $nextInput = $row
    .nextAll('.live-scoring-desktop-table__player-row')
    .first()
    .find('.live-scoring-desktop-score-input')
    .first();

  if ($nextInput.length) {
    if ($tableWrap.length) $tableWrap[0].scrollLeft = 0;
    $nextInput.trigger('focus');
    return;
  }

  $nextInput = $input
    .closest('.live-scoring-desktop-scorecard')
    .nextAll('.live-scoring-desktop-scorecard')
    .find('.live-scoring-desktop-score-input')
    .first();

  if ($nextInput.length) {
    $nextInput.trigger('focus');
    return;
  }

  $('#live-scoring-form .live-scoring-submit-btn--desktop:visible, #live-scoring-form [type=submit]:visible')
    .first()
    .trigger('focus');
}

function liveScoringSyncFormFieldsForLayout() {
  var mobile = liveScoringIsMobileLayout();

  $('#live-scoring-hidden-inputs input').prop('disabled', !mobile);
  $('.live-scoring-desktop-score-input').prop('disabled', mobile);
}

function liveScoringSyncScoresBetweenLayouts(nextLayout, previousLayout) {
  if (!previousLayout || previousLayout === nextLayout) return;

  $('.live-scoring-desktop-score-input').each(function () {
    var $desktop = $(this);
    var $hidden = $(liveScoringHiddenInputSelector(
      $desktop.data('teamId'),
      $desktop.data('playerId'),
      $desktop.data('holeId')
    ));

    if ($hidden.length === 0) return;

    if (nextLayout === 'mobile') {
      $hidden.val($desktop.val());
    } else {
      $desktop.val($hidden.val());
    }
  });
}

module.exports = {
  draftKey: liveScoringDraftKey,
  hiddenInputSelector: liveScoringHiddenInputSelector,
  parseEntries: liveScoringParseEntries,
  isMobileLayout: liveScoringIsMobileLayout,
  clampParDiff: liveScoringClampParDiff,
  allowX: liveScoringAllowX,
  displayForValue: liveScoringDisplayForValue,
  parDiffForValue: liveScoringParDiffForValue,
  scoreValueForTotal: liveScoringScoreValueForTotal,
  isEmptyScoreValue: liveScoringIsEmptyScoreValue,
  numericScoreValue: liveScoringNumericScoreValue,
  normalizeInputValue: liveScoringNormalizeInputValue,
  applyScoreInputMask: liveScoringApplyScoreInputMask,
  parDiffDisplayHtml: liveScoringParDiffDisplayHtml,
  focusNextScoreInput: liveScoringFocusNextScoreInput,
  syncFormFieldsForLayout: liveScoringSyncFormFieldsForLayout,
  syncScoresBetweenLayouts: liveScoringSyncScoresBetweenLayouts,
};
